export enum CertificationStatus {
    SUCCEEDED = 'SUCCEEDED',
    FAILED = 'FAILED',
    PARTIAL = 'PARTIAL',
}
